module.exports = __webpack_public_path__ + "static/media/thank-you-page-top-half.3e6ec075.svg";